import { trigger, transition, style, animate, state } from '@angular/animations';

export const ANIMATION_SLIDE_LEFT_COMPONENT = [
    trigger('slideInLeft', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.1s ease-in', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('0.1s ease-out', style({ transform: 'translateX(-100%)', opacity: 0 }))
      ])
    ])
];

export const ANIMATION_SLIDE_BOTTOM_COMPONENT = [
  trigger('slideUpDown', [
    state('hidden', style({
      opacity: 0,
      transform: 'translateY(100%)'
    })),
    state('visible', style({
      opacity: 1,
      transform: 'translateY(0)'
    })),
    transition('hidden => visible', [
      animate('300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)')
    ]),
    transition('visible => hidden', [
      animate('300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)')
    ])
  ])
];
